export function isStaging(): boolean {
  const envValues = [
    import.meta.env.MODE,
    import.meta.env.VITE_APP_ENV,
    import.meta.env.VITE_ENV,
    import.meta.env.VITE_DEPLOY_ENV,
  ]
    .filter(Boolean)
    .map((value) => String(value).toLowerCase());

  if (envValues.some((value) => ["test", "testing", "staging", "preview"].includes(value))) {
    return true;
  }

  if (typeof window === "undefined") return false;

  const hostname = window.location.hostname.toLowerCase();
  return (
    hostname.includes("staging")
  );
}

export function getClientEnvironmentLabel(): string {
  if (typeof window === "undefined") return "ambiente de testes";
  const hostname = window.location.hostname;
  if (hostname === "localhost" || hostname === "127.0.0.1" || hostname === "::1") {
    return "localhost";
  }
  if (hostname.toLowerCase().includes("staging")) return "staging";
  return import.meta.env.MODE || "ambiente de testes";
}
